module.exports = __webpack_public_path__ + "img/download.6393b02e.svg";